/**
 * Fire-and-forget interaction tracking via sendBeacon.
 * @param {string} event - Event name (must match VALID_EVENTS in backend)
 * @param {object} [props] - Optional props (service, source, query, resultsCount, ctaName)
 */
export function trackInteraction(event, props) {
  try {
    const payload = { event, props }
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' })
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/analytics/interaction-event', blob)
    } else {
      fetch('/api/analytics/interaction-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => { /* non-blocking */ })
    }
  } catch { /* non-blocking */ }
}
